import { Http } from '@/lib/http';
import { assertRangeRows } from '@/modules/shared/utils/range-row-limits.mjs';
import {
  assertUniqueLoanProductName,
  normalizeLoanProductNameForSave
} from '@/modules/global-settings/loan-origination/utils/loan-product-name';

export class LoanProductService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/loan-products/';
  }
  getLoanProducts() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  getLoanProductFilterOptions() {
    return this.httpClient().get(`${this.endpoint}filter-options`);
  }
  getLoanProduct(id) {
    return this.httpClient().get(`${this.endpoint}${id}`);
  }
  normalizeLoanProductPayload(payload) {
    const normalizedPayload = { ...payload };

    if (
      Object.prototype.hasOwnProperty.call(normalizedPayload, 'loanProductName')
    ) {
      normalizedPayload.loanProductName = normalizeLoanProductNameForSave(
        normalizedPayload.loanProductName
      );
    }

    return normalizedPayload;
  }
  async assertUniqueName(payload) {
    if (!Object.prototype.hasOwnProperty.call(payload, 'loanProductName')) {
      return;
    }

    const { data } = await this.getLoanProducts();
    assertUniqueLoanProductName(data, payload);
  }
  async createLoanProduct(payload) {
    const normalizedPayload = this.normalizeLoanProductPayload(payload);
    assertRangeRows(normalizedPayload?.serviceCharges);
    await this.assertUniqueName(normalizedPayload);
    return this.httpClient().post(`${this.endpoint}`, normalizedPayload);
  }
  async updateLoanProduct(payload) {
    const normalizedPayload = this.normalizeLoanProductPayload(payload);
    assertRangeRows(normalizedPayload?.serviceCharges);
    await this.assertUniqueName(normalizedPayload);
    return this.httpClient().patch(
      `${this.endpoint}${normalizedPayload.id}`,
      normalizedPayload
    );
  }
}